import { LAUNCH_TOKEN_QUERY_PARAM } from './handoffConstants';

/**
 * Read the launch token from the URL and immediately strip it from the address
 * bar via `history.replaceState`, so it never lingers in history or the Referer.
 */
export const readAndClearLaunchToken = () => {
	const url = new URL(window.location.href);
	const token = url.searchParams.get(LAUNCH_TOKEN_QUERY_PARAM);

	if (token) {
		url.searchParams.delete(LAUNCH_TOKEN_QUERY_PARAM);
		window.history.replaceState({}, '', url.toString());
	}

	return token;
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
